export default __webpack_public_path__ + "static/media/background-about-desktop.5d9db2fb.png";